<template>
    <div
        class="sidebar"
        :class="{ 'tracking-aside': mode == MODE_TAB }"
    >
        <ul class="links">
            <li class="links__tile" v-for="(link, key) in links" :key="link.routeName || key">
                <router-link v-if="link.hasPermissions && link.mode == MODE_ROUTER" :to="{ name: link.routeName }">
                    <side-menu-item :link="link"></side-menu-item>
                </router-link>

                <side-menu-item
                    v-if="link.hasPermissions && link.mode == MODE_TAB"
                    @click.native="onTabChange(link.name)"
                    :isActive="link.name === getActiveTrackingAsideTab"
                    :link="link"
                />

                <side-menu-item
                    v-if="link.hasPermissions && link.mode == MODE_ACTION"
                    :class="{ 'links--disabled': link.disabled }"
                    @click.native="runAction(link.action, link.disabled)"
                    :isActive="link.name === getActiveTrackingAsideTab"
                    :link="link"
                />
            </li>
        </ul>
    </div>
</template>

<script>

import SideMenuItem from '@/components/layout/SideMenu/SideMenuItem'
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'SideMenu',
    components: {
        SideMenuItem
    },
    data () {
        return {
            MODE_ROUTER: 'router',
            MODE_TAB: 'tab',
            MODE_ACTION: 'action'
        }
    },
    props: {
        links: {
            type: Array,
            required: true
        },
        mode: {
            type: String,
            required: false,
            default: 'router'
        }
    },
    computed: {
        ...mapGetters({
            getActiveTrackingAsideTab: 'layoutModule/getActiveTrackingAsideTab'
        }),
    },
    methods: {
        onTabChange(tabName) {
            if (this.getActiveTrackingAsideTab !== tabName) {
                this.setActiveTrackingAsideTab(tabName);
            }
        },
        runAction (method, isDisabled) {
            console.debug('SideMenu::runAction', method)

            if (isDisabled) {
                return
            }

            method();
        },
        ...mapActions({
            setActiveTrackingAsideTab: 'layoutModule/setActiveTrackingAsideTab'
        }),
    }
}
</script>

<style lang="scss" scoped>
.sidebar {
    box-shadow: 4px 0 8px 0 rgba(0, 0, 0, 0.15);
    background: $secondary;
    width: 150px;
    height: 100%;
    .links {
        list-style: none;
        padding: 0;
        a:hover {
            text-decoration: none;
        }
        &__tile {
            cursor: pointer;
        }

        &--disabled {
            cursor: not-allowed;
            opacity: 0.3;
        }
    }
}
.tracking-aside {
    width: 125px;
}
</style>
